// src/api/adminViewApi.ts
import { AdminConsolidatedViewReponse } from "../types/adminViewConsolidateResponse";
import axiosInstance from "./axiosInstance";

export const getConsolidatedView = async (): Promise<AdminConsolidatedViewReponse[]> => {
  try {
    const response = await axiosInstance.get("/api/admin/consolidated-view");
    return response.data; // TypeScript will infer the return type as ConsolidatedViewRow[]
  } catch (error) {
    console.error("Error fetching consolidated view data:", error);
    throw error;
  }
};
